import { observable } from "mobx";
import { Type } from "class-transformer";
import CounterpartyBankAccountRequest from "./counterpartyBankAccountRequest";
import InternalTransferApprovalType from "./internalTransferApprovalType";
import { ApprovalState } from "./approvalState";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class InternalTransfersRequest {
  /**
   * Number of records to be selected.
   * @example
   * 20
   */
  @observable
  limit?: number;

  @observable
  offset?: number;

  @observable
  fullTextSearchEnabled?: boolean;

  @observable
  @Type(() => CounterpartyBankAccountRequest)
  senderBankAccount?: CounterpartyBankAccountRequest;

  @observable
  @Type(() => CounterpartyBankAccountRequest)
  recipientBankAccount?: CounterpartyBankAccountRequest;

  @observable
  messageForRecipient?: string;

  @observable
  amount?: number;

  @observable
  variableSymbol?: number;

  @observable
  constantSymbol?: number;

  @observable
  specificSymbol?: number;

  @observable
  approvedBy?: InternalTransferApprovalType;

  @observable
  notApprovedBy?: InternalTransferApprovalType;

  @observable
  isExported?: boolean;

  @observable _approvalState?: ApprovalState;
}
